<div class="card m-0">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="m-0 fw-bold">Event Details</h6>
      </div>
      <div class="col-auto">
        <button type="button" class="btn" (click)="modal.hide()">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body" *ngIf="data">
    <app-event-card
      [event]="data"
      [type]="type"
      [details]="false"
      [truncate]="false"
      colImage="col-12"
    ></app-event-card>
  </div>
</div>
